import { observer } from "mobx-react-lite";
import * as React from "react";
import {
  ZPrimSchemaLinkItem,
  ZSchemaLinks,
  ZSecondarySchemaLinkClass,
  ZSecondarySchemaLinks,
} from "src/business/specification";

import { SpecLinksCommon } from "../ManagementSpecCommonCard/ManagementSpecCommonCardStore";
import {
  specLinksPrimaryCatalogsColumns,
  specLinksPrimaryClassifiersColumns,
  specLinksSecondaryClassesColumns,
} from "./specLinksColumns";
import { SpecLinksSection, SpecLinksView } from "./SpecLinksView";

type SpecLinksHandler<T extends ZSchemaLinks | ZSecondarySchemaLinks> = {
  createSections: (data: T) => React.ReactNode;
};

type SpecLinksRegistry = {
  primary: SpecLinksHandler<ZSchemaLinks>;
  secondary: SpecLinksHandler<ZSecondarySchemaLinks>;
};

const specLinksRegistry: SpecLinksRegistry = {
  primary: {
    createSections: (data: ZSchemaLinks) => {
      const sections: SpecLinksSection<ZPrimSchemaLinkItem>[] = [
        {
          key: "catalogs",
          label: `Каталоги: ${data.catalogs?.length ?? 0}`,
          dataSource: data.catalogs,
          columns: specLinksPrimaryCatalogsColumns,
        },
        {
          key: "classifiers",
          label: `Классификаторы: ${data.classifiers?.length ?? 0}`,
          dataSource: data.classifiers,
          columns: specLinksPrimaryClassifiersColumns,
        },
      ];
      return <SpecLinksView sections={sections} />;
    },
  },
  secondary: {
    createSections: (data: ZSecondarySchemaLinks) => {
      const sections: SpecLinksSection<ZSecondarySchemaLinkClass>[] = [
        {
          key: "classes",
          label: `Классы: ${data.classes?.length ?? 0}`,
          dataSource: data.classes,
          columns: specLinksSecondaryClassesColumns,
        },
      ];
      return <SpecLinksView sections={sections} />;
    },
  },
};

type PropsSpecLinksCollapseList = {
  linksData: SpecLinksCommon | null;
};

export const SpecLinksCollapseList: React.FC<PropsSpecLinksCollapseList> =
  observer(({ linksData }) => {
    if (!linksData) return null;
    const handler = specLinksRegistry[linksData.specType];
    const sections = handler.createSections(linksData.data);
    return sections;
  });
